import { Client, getClient, userLanguageDaOverride } from '@glow/common'
import capitalize from 'lodash-es/capitalize'
import { Helmet } from 'react-helmet-async'
import { withBase } from '../../utils/appBase'

type IconAssets = {
  appleTouchIcon: string
  favicon: string
  favicon16x16?: string
  favicon32x32?: string
  manifest: string
  maskIcon: string
}

const iconAssets = {
  bring: {
    appleTouchIcon: 'appleTouchIcon.png',
    favicon: 'favicon.ico',
    favicon16x16: undefined,
    favicon32x32: undefined,
    manifest: 'site.webmanifest',
    maskIcon: 'safari-pinned-tab.svg'
  },
  glow: {
    appleTouchIcon: 'appleTouchIcon.png',
    favicon: 'favicon.ico',
    favicon16x16: 'favicon16x16.png',
    favicon32x32: 'favicon32x32.png',
    manifest: 'site.webmanifest',
    maskIcon: 'safari-pinned-tab.svg'
  }
} satisfies Record<Client, IconAssets>

export function MetaTags() {
  const client = getClient()
  const assets = iconAssets[client]
  const title = capitalize(client)
  const appName = `Track your delivery - ${client}`
  const lang = userLanguageDaOverride()
  return (
    <>
      <Helmet htmlAttributes={{ lang }}>
        <meta name="apple-mobile-web-app-title" content={appName} />
        <meta name="application-name" content={appName} />

        <meta content={title} property="og:title" />
        <meta content={title} property="og:site_name" />
        <meta content={title} property="og:description" />
        <meta content="website" property="og:type" />

        <link rel="apple-touch-icon" sizes="180x180" href={withBase(`/${client}/${assets.appleTouchIcon}`)} />
        <link rel="mask-icon" href={withBase(`/${client}/${assets.maskIcon}`)} />
        <link rel="manifest" href={withBase(`/${client}/${assets.manifest}`)} />
      </Helmet>
      <Favicons client={client} />
    </>
  )
}

function Favicons({ client }: { client: Client }) {
  const assets = iconAssets[client]

  return (
    <Helmet>
      {assets.favicon16x16 && (
        <link rel="icon" type="image/png" href={withBase(`/${client}/${assets.favicon16x16}`)} sizes="16x16" />
      )}
      {assets.favicon32x32 && (
        <link rel="icon" type="image/png" href={withBase(`/${client}/${assets.favicon32x32}`)} sizes="32x32" />
      )}
      <link rel="shortcut icon" href={withBase(`/${client}/${assets.favicon}`)} />
    </Helmet>
  )
}
